export const REQUEST_PENDING_TREATEMENT_CLAIMS =
  'REQUEST_PENDING_TREATEMENT_CLAIMS';
export const SET_PENDING_TREATEMENT_CLAIMS = 'SET_PENDING_TREATEMENT_CLAIMS';
export const REQUEST_SEARCH_PENDING_TREATEMENT_CLAIMS =
  'REQUEST_SEARCH_PENDING_TREATEMENT_CLAIMS';
